/**
 * Course ID normalization utility
 * Handles various naming conventions and aliases
 *
 * This is a separate file to avoid circular dependencies between
 * courseService.js and lessonsRegistry.js
 */

// Course aliases - handles legacy naming conventions
// Note: southstreetschool was a bug, kept for backwards compatibility
const COURSE_ALIASES = {
  southstreetschool: 'southstreet',
};

/**
 * Normalize any course name to canonical form
 * Handles 'southstreetschool' -> 'southstreet', case insensitivity, etc.
 * @param {string} courseId - Course identifier to normalize
 * @returns {string|null} - Normalized course ID or null if input is falsy
 */
export function normalizeCourseId(courseId) {
  if (!courseId) return null;
  const lower = courseId.toLowerCase();
  return COURSE_ALIASES[lower] || lower;
}
